import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { MobileCTABar, BackToTop } from "@/components/site/MobileCTABar";
import { ScrollProgress } from "@/components/site/ScrollProgress";
import { ScrollToTop } from "@/components/site/ScrollToTop";
import Home from "@/pages/Home";
import IdxPage from "@/pages/IdxPage";
import BuyPage from "@/pages/BuyPage";
import SellPage from "@/pages/SellPage";
import JoinPage from "@/pages/JoinPage";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import FinancingPage from "@/pages/FinancingPage";
import AreasPage from "@/pages/AreasPage";
import AgentsPage from "@/pages/AgentsPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";

// /post/:slug is the old GoHighLevel blog URL pattern. Redirect it to the
// equivalent /blog/:slug route instead of duplicating BlogPostPage.
function LegacyPostRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/blog/${slug}`} replace />;
}

function App() {
return (
<div className="App bg-white">
<BrowserRouter>
<ScrollProgress />
<ScrollToTop />
<Header />
<main>
<Routes>
<Route path="/" element={<Home />} />
{/* IDX search, results, and property detail pages all render
under /idx via the iHomeFinder Kestrel widget. */}
<Route path="/idx/*" element={<IdxPage />} />
<Route path="/search" element={<Navigate to="/idx" replace />} />
<Route path="/listings" element={<Navigate to="/idx" replace />} />
<Route path="/advanced-search" element={<Navigate to="/idx" replace />} />
<Route path="/apply-to-join" element={<Navigate to="/join" replace />} />
<Route path="/find-an-agent-171637" element={<Navigate to="/agents" replace />} />
<Route path="/buy" element={<BuyPage />} />
<Route path="/sell" element={<SellPage />} />
<Route path="/join" element={<JoinPage />} />
<Route path="/contact" element={<ContactPage />} />
<Route path="/about" element={<AboutPage />} />
<Route path="/financing" element={<FinancingPage />} />
<Route path="/areas" element={<AreasPage />} />
<Route path="/agents" element={<AgentsPage />} />
<Route path="/blog" element={<BlogPage />} />
<Route path="/blogs" element={<Navigate to="/blog" replace />} />
<Route path="/blog-506741" element={<Navigate to="/blog" replace />} />
<Route path="/blog/:slug" element={<BlogPostPage />} />
<Route path="/post/:slug" element={<LegacyPostRedirect />} />
<Route path="*" element={<Navigate to="/" replace />} />
</Routes>
</main>
<Footer />
<div className="h-14 lg:hidden" aria-hidden="true" />
<MobileCTABar />
<BackToTop />
</BrowserRouter>
</div>
);
}

export default App;
